// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f4f4f4;
    padding: 20px;
  }
  
  .login-box {
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    padding: 50px 40px;
    width: 100%;
    max-width: 420px;
    text-align: center;
  }
  
  .sze-logo {
    width: 100%;
    max-width: 300px;
    height: auto;
    margin-bottom: 20px;
  }

  .login-box h2 {
    margin-bottom: 30px;
    font-size: 22px;
    font-weight: bold;
    color: #333;
  }

  /* Error Message */
  .error-message {
    background-color: #fee;
    border: 1px solid #fcc;
    color: #c33;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 25px;
    text-align: center;
    font-size: 14px;
    line-height: 1.5;
  }

  /* Shibboleth Login Button */
  .shibboleth-login-button {
    width: 100%;
    padding: 18px;
    background-color: #44ACC9;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-bottom: 20px;
  }

  .shibboleth-login-button:hover {
    background-color: #357a9d;
  }

  .shibboleth-login-button:active {
    transform: translateY(0);
  }

  .shibboleth-login-button:focus {
    outline: none;
  }

  .shibboleth-icon {
    font-size: 24px;
  }

  /* Login Info Text */
  .login-info {
    color: #666;
    font-size: 14px;
    line-height: 1.6;
    margin: 0;
  }

  /* Responsive Design */
  @media (max-width: 480px) {
    .login-box {
      padding: 40px 25px;
    }

    .login-box h2 {
      font-size: 26px;
    }

    .shibboleth-login-button {
      font-size: 16px;
      padding: 15px;
    }

    .login-info {
      font-size: 13px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/routes/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;;EAEA,kBAAkB;EAClB;IACE,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA,4BAA4B;EAC5B;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA,oBAAoB;EACpB;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,SAAS;EACX;;EAEA,sBAAsB;EACtB;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":[".login-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    background-color: #f4f4f4;\n    padding: 20px;\n  }\n  \n  .login-box {\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n    padding: 50px 40px;\n    width: 100%;\n    max-width: 420px;\n    text-align: center;\n  }\n  \n  .sze-logo {\n    width: 100%;\n    max-width: 300px;\n    height: auto;\n    margin-bottom: 20px;\n  }\n\n  .login-box h2 {\n    margin-bottom: 30px;\n    font-size: 22px;\n    font-weight: bold;\n    color: #333;\n  }\n\n  /* Error Message */\n  .error-message {\n    background-color: #fee;\n    border: 1px solid #fcc;\n    color: #c33;\n    padding: 12px;\n    border-radius: 8px;\n    margin-bottom: 25px;\n    text-align: center;\n    font-size: 14px;\n    line-height: 1.5;\n  }\n\n  /* Shibboleth Login Button */\n  .shibboleth-login-button {\n    width: 100%;\n    padding: 18px;\n    background-color: #44ACC9;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 18px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    margin-bottom: 20px;\n  }\n\n  .shibboleth-login-button:hover {\n    background-color: #357a9d;\n  }\n\n  .shibboleth-login-button:active {\n    transform: translateY(0);\n  }\n\n  .shibboleth-login-button:focus {\n    outline: none;\n  }\n\n  .shibboleth-icon {\n    font-size: 24px;\n  }\n\n  /* Login Info Text */\n  .login-info {\n    color: #666;\n    font-size: 14px;\n    line-height: 1.6;\n    margin: 0;\n  }\n\n  /* Responsive Design */\n  @media (max-width: 480px) {\n    .login-box {\n      padding: 40px 25px;\n    }\n\n    .login-box h2 {\n      font-size: 26px;\n    }\n\n    .shibboleth-login-button {\n      font-size: 16px;\n      padding: 15px;\n    }\n\n    .login-info {\n      font-size: 13px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
